/* tslint:disable:typedef-whitespace align no-trailing-whitespace import-spacing */

import {Action, ActionType}      from '@/models/action';
import {Logger}                  from '@/util/logger';
import {WindowService}           from "@/services/window.service";
import {TSOEditorMetadata}       from '@/screens/ide/t.s.o.editor.metadata';

/**
 *
 * @class TSOEditAction
 *
 * @brief launch a new / blank train slow orders (TSO) editor
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      July 2020
 *
 */
export class TSOEditAction extends Action {

  private      windows: WindowService = null;

  constructor(options: any = null) {

    super({
      key:   'window.tsoeditor',
      type:  ActionType.Window_TSO,
      label: 'TSO Editor (Empty)',
      icon:  '<i class="fas fa-tools"></i>',
      tip:   'Launch a TSO editor'
    });

    this.windows  = this.injector().get(WindowService);
  }

  /* is this action enabled? */
  public enabled(): boolean {

    return true;
  }

  /** implement the action */
  public execute(): boolean {

    if (!this.enabled()) {
      return false;
    }

    Logger.debug('[TSOEditAction] executing...');

    this.windows.launchWindow(new TSOEditorMetadata(
      '',
      '',
      ''
    ));

    return true;
  }
}
